import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const pixelId = '2020793225485829';
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => {
      // @ts-ignore
      if (window.fbq) {
        // @ts-ignore
        window.fbq('init', pixelId);
        // @ts-ignore
        window.fbq('track', 'PageView');
      }
    };
    document.head.appendChild(script);
    // Initialize fbq queue immediately so calls before onload are buffered
    // @ts-ignore
    if (!window.fbq) {
      // @ts-ignore
      const fbq: any = function () {
        // @ts-ignore
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      // @ts-ignore
      window.fbq = fbq;
      // @ts-ignore
      window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      // @ts-ignore
      window.fbq('init', pixelId);
      // @ts-ignore
      window.fbq('track', 'PageView');
    }
  }, []);
  return <>
      <SalesPage data-id="element-0" />
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2020793225485829&ev=PageView&noscript=1" data-id="element-2" />
      </noscript>
    </>;
}